import { AnimatePresence, motion } from 'framer-motion';
import PropTypes, { array } from 'prop-types';
import React from 'react';
import LoadingAnimation from '../../assets/imgs/loading_animation.gif';
import { UseSortLoadingMessages } from './hooks/useSortLoadingMessages';
import styles from './styles.module.css';



function LoadingMessage({
  messagesArray1,
  messagesArray2,
  messagesTime = 1000,
  onFinishFirstArray,
}) {

  const {messagesArray, setIsDoneFirstArray, isDoneFirstArray} = UseSortLoadingMessages(messagesArray1, messagesArray2 )
    
  const onFinishStable = React.useCallback((v) =>  setIsDoneFirstArray(v), []);

  const [i, setI] = React.useState(0);
  const has = messagesArray.length > 0;

  React.useEffect(() => {
    if (!has) return;
    const id = setTimeout(() => {
      setI((prev) => {
        const next = (prev + 1) % messagesArray.length;
        if (!isDoneFirstArray && prev ===messagesArray.length - 1){
          onFinishStable(true);
        }else if(isDoneFirstArray && prev === messagesArray.length - 1){
          return 0
        }
         
        return next;
      });
    }, messagesTime);
    return () => clearTimeout(id);
  }, [i, has, messagesArray, messagesTime, onFinishFirstArray, isDoneFirstArray]);

  return (
    <div className={styles.container}>
      <div className={styles.image_container}>
        <img src={LoadingAnimation} alt="loading" />
      </div>
      <div className={styles.bottom_container}>
        <div className={styles.messages_container}>
          <AnimatePresence mode="wait">
            {has && (
              <motion.p
                key={i}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
              >
                {messagesArray[i]}
              </motion.p>
            )}
          </AnimatePresence>
        </div>
        <div className={styles.progress_bar_container}>{/* ... */}</div>
      </div>
    </div>
  );
}

LoadingMessage.propTypes = {
  messagesArray1:PropTypes.array,
  messagesArray2:PropTypes,array,
  messagesTime: PropTypes.number,
  onFinishFirstArray: PropTypes.func,
  
};

export const LoadingMessageMemoized =  React.memo(LoadingMessage,(prev, next) =>
  prev.messagesArray1 === next.messagesArray1 &&
  prev.messagesArray2 === next.messagesArray2 &&
  prev.messagesTime === next.messagesTime &&
  prev.onFinishFirstArray === next.onFinishFirstArray
);